/**
 * Экран заблокированного аккаунта. Причина приходит из проверки токена
 * (userBlockPage.cause в LayoutContext).
 */
import { useContext } from 'react';
import Cookies from 'js-cookie';

import { LayoutContext } from '../context';
import { PrimaryButton, StatusScreen,
    IconBan,
} from '../components/Auth/ui';

export default function UserBlockPage() {
    const { userBlockPage } = useContext(LayoutContext);
    const cause = userBlockPage?.cause && userBlockPage.cause !== 'Не указана'
        ? userBlockPage.cause
        : null;

    const logout = () => {
        Cookies.remove('authToken');
        Cookies.remove('authPlatform');
        try { localStorage.removeItem('authPlatform'); } catch (_e) { /* ignore */ }
        window.location.href = '/login';
    };

    return (
        <StatusScreen
            icon={<IconBan />}
            title="Доступ к анкете закрыт"
            text={cause
                ? `Причина: ${cause}. Если считаете, что это ошибка — напишите в поддержку.`
                : 'Анкета заблокирована модератором. Если считаете, что это ошибка — напишите в поддержку.'}
        >
            <PrimaryButton variant="ghost" onClick={logout}>Выйти</PrimaryButton>
        </StatusScreen>
    );
}
